import React from 'react'
import {useIntl} from 'react-intl'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Button} from '@daedalus/atlas/Button'
import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {Icon} from '@daedalus/atlas/Icon'
import {Text} from '@daedalus/atlas/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {dateStringToMiddayDate} from '@daedalus/core/src/utils/date'

interface SoldOutProps {
  checkInDate?: string
  checkOutDate?: string
  onClick?: () => void
}

const Container = styled('div')`
  max-width: 416px;
`

const ContentWrapper = styled('div')<{isMobile: boolean}>(
  ({isMobile}) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${isMobile ? 'flex-start' : 'center'};
  `
)

const TitleWrapper = styled('div')(
  ({theme}) => css`
    gap: ${theme.layout.spacing.s200}px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: ${theme.layout.spacing.s100}px;
  `
)

const ButtonWrapper = styled('div')(
  ({theme}) => css`
    padding-top: ${theme.layout.spacing.s500}px;
  `
)

export const SoldOut = ({checkInDate, checkOutDate, onClick}: SoldOutProps) => {
  const {isMobile} = useDeviceLayout()
  const {formatDate} = useIntl()

  return (
    <Container>
      <ContentWrapper isMobile={isMobile}>
        <TitleWrapper>
          <Icon name="Forbid" colorPath="content.danger.c500" />
          <Text variant="titleM">
            <FormattedMessageWrapper
              id="hotelCardWidget.soldOutTitle"
              defaultMessage="Sold out on your dates"
            />
          </Text>
        </TitleWrapper>
        <Text variant="bodyS" align={isMobile ? 'left' : 'center'}>
          {checkInDate && checkOutDate && (
            <FormattedMessageWrapper
              id="hotelCardWidget.soldOutDescription"
              defaultMessage="Your dates {checkInDate} - {checkOutDate} are in demand - we’ve run out of rooms at this property!"
              values={{
                checkInDate: formatDate(dateStringToMiddayDate(checkInDate), {
                  day: '2-digit',
                  month: 'short'
                }),
                checkOutDate: formatDate(dateStringToMiddayDate(checkOutDate), {
                  day: '2-digit',
                  month: 'short'
                })
              }}
            />
          )}
        </Text>
      </ContentWrapper>
      {onClick && (
        <ButtonWrapper>
          <Button variant="secondary" fullWidth onClick={onClick}>
            <FormattedMessageWrapper
              id="hotelCardWidget.changeDatesButton"
              defaultMessage="Change dates"
            />
          </Button>
        </ButtonWrapper>
      )}
    </Container>
  )
}
